
export { default as anyPass } from "./anyPass.js"
export { default as dissocPath } from "./dissocPath.js"
export { default as evolve } from "./evolve.js"
export { default as includes } from "./includes.js"
export { default as indexBy } from "./indexBy.js"
export { default as isEmpty } from "./isEmpty.js"
export { default as isNil } from "./isNil.js"
export { default as lensPath } from "./lensPath.js"
export { default as map } from "./map.js"
export { default as mergeLeft } from "./mergeLeft.js"
export { default as path } from "./path.js"
export { default as pick } from "./pick.js"
export { default as pipe } from "./pipe.js"
export { default as prop } from "./prop.js"
export { default as propEq } from "./propEq.js"
export { default as set } from "./set.js"
export { default as toLower } from "./toLower.js"
export { default as toUpper } from "./toUpper.js"